import { render, staticRenderFns } from "./OpportunityGroup.vue?vue&type=template&id=29d20502&scoped=true&"
import script from "./OpportunityGroup.vue?vue&type=script&lang=js&"
export * from "./OpportunityGroup.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityGroup.vue?vue&type=style&index=0&id=29d20502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d20502",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
